<template>
  <div id="app">
    <router-view v-show="!showError"></router-view>
    <v-app v-show="showError" light>
      <v-content>
        <v-container fluid v-show="showError">
          <v-row style="height: 600px" align="end">
            <v-card class="mx-auto" max-width="800" align="center" flat>
              <v-img height="319" width="319" :src="require('./assets/image/error.png')" @click="goNext"></v-img>
            </v-card>
          </v-row>
          <v-row style="height: 600px" align="end" justify="center">
            <div class="display-2 font-weight-bold">{{ errorText }}</div>
          </v-row>
        </v-container>
      </v-content>
    </v-app>
  </div>
</template>

<script>
export default {
  name: 'pos-pwa',
  data: () => ({
    showError: false,
    errorText: '',
  }),
  methods: {
    goNext() {
      this.showError = false;
    },
  },
  created() {
  },
  mounted() {
    window.onpopstate = () => {
      // eslint-disable-next-line no-restricted-globals
      history.go(1);
    };
  },
};
</script>
<!-- vuetify 預設使用Roboto字型，而且有部份元件有important, 所以更改該名稱字體為微軟正黑體 -->
<style></style>
